export const getReduxType = (status: string, method: string, entityName: string) => {
    return `${status}_${method}_${entityName}`.toUpperCase()
};

export const createUrl = (method : string, action : string) => {
    if (action.endsWith('USER'))
    {
        switch (method) {
            case 'POST':
                return "/user_create";
            case 'PUT':
                return "/user_update";
            case 'GET':
                return "/user_get";
        }
    }

    return "";
}
